export const casualPageConfig ={
  "title": "Revenue",
  "titleCN": "付费流水",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/monetization/revenue",
  "defaultTab": "revenue",
  "tabList": [
    {
      "id": "revenue",
      "tabName": "Revenue",
      "tabNameCN": "付费流水",
      "isHaveNotification": true,
      "path": "/monetization/revenue",
      "logConfig": {
        "pageId": "208401",
        "pageName": "monetizationRevenueIaa",
        "extInfo": "monetizationRevenueIaa",
        "pagePath": "/monetization/revenue"
      },
      "filters": [
        {
          "name": "RevenueFilterNewCo",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/monetization/revenue",
          "granularity": [
            "day"
          ],
          "dateOffSet": {
            "dayStartOffset": 1
          },
          "enableDateOffset": true,
          "extraFilterList": [
            "ad_format"
          ],
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "KeyMetricTitle"
                },
                {
                  "name": "CommonRow",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformMetricsCo",
                          "className": "margin-t-10",
                          "type": "view",
                          "props": {
                            "config": {
                              "componentLoadingHight": 166,
                              "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                              "metricsList": [
                                "iaa_revenue"
                              ],
                              "serviceParams": {
                                "breakdown_dimension": "ad_format"
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "IAARevenuePlatformCard",
                              "height": 166,
                              "config": {
                                "props": {
                                  "dimension": "ad_format",
                                  "style": {
                                    "minHeight": "166px"
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformMetricsCo",
                          "className": "margin-t-10",
                          "type": "view",
                          "props": {
                            "config": {
                              "componentLoadingHight": 166,
                              "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                              "metricsList": [
                                "ecpm"
                              ],
                              "serviceParams": {
                                "breakdown_dimension": "ad_format",
                                "logical_flag": "top_no_others"
                              },
                              "otherParams": "function(data) { const existingCustomFilters = data?.custom_filters || []; const adFormatFilter = existingCustomFilters.find(item => item.key === 'ad_format'); if (adFormatFilter) { adFormatFilter.filter_list = ['interstitial', 'banner', 'rewarded']; } else { existingCustomFilters.push({ key: 'ad_format', filter_list: ['interstitial', 'banner', 'rewarded'] }); } return { filters: { ...data, custom_filters: existingCustomFilters } }; }"
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "EcpmPlatformCard",
                              "height": 166,
                              "config": {
                                "props": {
                                  "dimension": "ad_format",
                                  "style": {
                                    "minHeight": "166px"
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "children": [
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformMetricsCo",
                          "className": "margin-t-10",
                          "type": "view",
                          "props": {
                            "config": {
                              "componentLoadingHight": 166,
                              "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                              "metricsList": [
                                "iaa_impressions"
                              ],
                              "serviceParams": {
                                "breakdown_dimension": "ad_format"
                              }
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "ImpressionsPlatformCard",
                              "height": 166,
                              "config": {
                                "props": {
                                  "dimension": "ad_format",
                                  "style": {
                                    "minHeight": "166px"
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "type": "layout",
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformMetricsCo",
                          "className": "margin-t-10",
                          "type": "view",
                          "props": {
                            "config": {
                              "componentLoadingHight": 166,
                              "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                              "metricsList": [
                                "imps_per_dau"
                              ],
                              "serviceParams": {
                                "breakdown_dimension": "ad_format",
                                "logical_flag": "top_no_others"
                              },
                              "otherParams": "function(data) { const existingCustomFilters = data?.custom_filters || []; const adFormatFilter = existingCustomFilters.find(item => item.key === 'ad_format'); if (adFormatFilter) { adFormatFilter.filter_list = ['interstitial', 'banner', 'rewarded']; } else { existingCustomFilters.push({ key: 'ad_format', filter_list: ['interstitial', 'banner', 'rewarded'] }); } return { filters: { ...data, custom_filters: existingCustomFilters } }; }"
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "ImpsPerDauPlatformCard",
                              "height": 166,
                              "config": {
                                "props": {
                                  "hasChart": false,
                                  "dimension": "ad_format",
                                  "style": {
                                    "minHeight": "166px"
                                  }
                                }
                              }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "KeyMetricsCo",
                  "className": "dbd-daily-card",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                      "haveJump": false,
                      "loadingHeight": 151,
                      "mainMetricsList": [
                        "active_users",
                        "arpu",
                        "iaa_viewers"
                      ],
                      "metricsList": [
                        "active_users",
                        "arpu",
                        "iaa_viewers"
                      ],
                      "formatRules": [
                        {
                          "keys": [
                            "trend_list.metrics.arpu.value",
                            "trend_list.metrics.arpu.last_value"
                          ],
                          "format": "twoDecimal"
                        }
                      ]
                    }
                  },
                  "children": [
                    {
                      "name": "CommonRow",
                      "children": [
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 8
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "ActiveUsersMetricCard",
                              "height": 151
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 8
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "IaaViewersMetricCard",
                              "height": 151
                            }
                          ]
                        },
                        {
                          "name": "CommonCol",
                          "className": "",
                          "type": "layout",
                          "style": {},
                          "props": {
                            "w": 8
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "ArpuMetricCard",
                              "height": 151
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "EventService",
                  "className": "",
                  "type": "view",
                  "style": {
                    "marginTop": "10px"
                  },
                  "props": {
                    "removeEventNumLimit": true
                  },
                  "children": [
                    {
                      "name": "MetricComponent",
                      "style": {
                        "marginTop": 20
                      },
                      "path": "monetization/revenue",
                      "componentKey": "OverviewMetricsTrendCo",
                      "height": 467,
                      "data": {
                        "trendMetrics": [
                          "iaa_revenue",
                          "iaa_dau",
                          "iaa_arpu",
                          "ecpm",
                          "iaa_impressions",
                          "imps_per_dau",
                          "imps_per_viewers",
                          "ad_viewer_rate",
                          "iaa_viewers",
                          "funnel_cache_succ_rate_per",
                          "funnel_ready_rate_per"
                        ]
                      },
                      "config": {
                        "props": {
                          "config": {
                            "enableFullScreen": true,
                            "eventTypeMaxCount": 3,
                            "fullScreenEnhancements": {
                              "showEventFilter": true,
                              "eventFilterBesideTitle": true,
                              "showEventWindows": true,
                              "excludeEventTypes": ["Holiday"],
                              "persistEventSetting": true,
                              "showSegmentTabsInFullScreen": true,
                              "eventBubbleDetailsNav": {
                                "minCountExclusive": 0,
                                "path": "eventAnalysis/eventDetails",
                                "query": {
                                  "timeType": "Day",
                                  "dashboardType": "overview"
                                }
                              },
                              "eventTypeBarColorMap": {
                                "版更": {
                                  "tagStyleAliases": ["Version"],
                                  "eventTooltips": "#F19E55"
                                },
                                "Version": {
                                  "eventTooltips": "#F19E55"
                                },
                                "玩法": {
                                  "tagStyleAliases": ["Gameplay"],
                                  "eventTooltips": "#1DB440"
                                },
                                "实验": {
                                  "tagStyleAliases": [
                                    "Experiment",
                                    "A/B Test",
                                    "AB Test",
                                    "ABTest"
                                  ],
                                  "eventTooltips": "#6E7794"
                                }
                              }
                            },
                            "api": {
                              "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend_v2",
                              "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend_v2",
                              "beforeDimensionApiRequest": "function(data) {\n                                                                var _data_accumulation_custom_accumulation_find, _data_accumulation_custom_accumulation, _data_accumulation;\n                                                                var isByAdFormat = (data === null || data === void 0 ? void 0 : (_data_accumulation = data.accumulation) === null || _data_accumulation === void 0 ? void 0 : (_data_accumulation_custom_accumulation = _data_accumulation.custom_accumulation) === null || _data_accumulation_custom_accumulation === void 0 ? void 0 : (_data_accumulation_custom_accumulation_find = _data_accumulation_custom_accumulation.find(function(a) {\n                                                                    return (a === null || a === void 0 ? void 0 : a.key) === 'ad_format';\n                                                                })) === null || _data_accumulation_custom_accumulation_find === void 0 ? void 0 : _data_accumulation_custom_accumulation_find.is_accumulation) === true;\n                                                                var result = Object.assign({}, data, isByAdFormat && {\n                                                                    logical_flag: 'show_all_data'\n                                                                }, !isByAdFormat && {\n                                                                    top_num: 3,\n                                                                    logical_flag: 'show_all_data,others_data'\n                                                                });\n                                                                return result;\n                                                            }"
                            },
                            "eventTypesDisplayLast": [
                              "Holiday"
                            ],
                            "formatRules": [
                              {
                                "keys": [
                                  "metrics.avg_active_user_matches.value",
                                  "metrics.avg_active_user_matches.last_value",
                                  "metrics.avg_active_user_matches.last_avg_value"
                                ],
                                "format": "int"
                              },
                              {
                                "keys": [
                                  "metrics.avg_new_user_matches.value",
                                  "metrics.avg_new_user_matches.last_value",
                                  "metrics.avg_new_user_matches.last_avg_value"
                                ],
                                "format": "int"
                              }
                            ]
                          }
                        }
                      }
                    }
                  ]
                },
                {
                  "name": "RankListTabCo",
                  "className": "dbd-rank-list-tab-co--casual",
                  "style": {},
                  "props": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "country",
                    "tabOrder": [
                      "country",
                      "region",
                      "platform",
                      "ad_format",
                      "ua_network",
                      "campaign",
                      "version"
                    ],
                    "optionsInit": [
                      {
                        "value": "platform",
                        "textEn": "Platform",
                        "textCn": "平台"
                      },
                      {
                        "value": "ad_format",
                        "textEn": "Ad Format",
                        "textCn": "广告类型"
                      },
                      {
                        "value": "ua_network",
                        "textEn": "Media Channel",
                        "textCn": "买量渠道"
                      },
                      {
                        "value": "campaign",
                        "textEn": "Campaign",
                        "textCn": "Campaign"
                      },
                      {
                        "value": "version",
                        "textEn": "Version",
                        "textCn": "版本"
                      }
                    ]
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 24
                      },
                      "children": [
                        {
                          "name": "MonetizationRevenueTrendCo",
                          "className": "dbd-monetization-revenue-trend-co--casual",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/overview_daily/overall_performance",
                              "isSegmentFilter": true,
                              "dataKey": "MonetizationRankData",
                              "formatParams": "function(data) {\n                                                                var _this, _this1;\n                                                                var byType = (data === null || data === void 0 ? void 0 : data.by_type) || 'country';\n                                                                var customKeys = [\n                                                                    'ad_format',\n                                                                    'ua_network',\n                                                                    'campaign',\n                                                                    'version'\n                                                                ];\n                                                                var isCustom = customKeys.includes(byType);\n                                                                var accumulation = {\n                                                                    not_by_date: true,\n                                                                    by_country: byType === 'country',\n                                                                    by_region: byType === 'region',\n                                                                    by_system: byType === 'platform',\n                                                                    \"by_zone\": false,\n                                                                    \"by_channel\": false,\n                                                                    \"by_language\": false,\n                                                                    \"by_bundle\": false,\n                                                                    \"by_churn_level\": false,\n                                                                    \"by_product\": false,\n                                                                    \"by_category\": false\n                                                                };\n                                                                if (isCustom) {\n                                                                    accumulation.custom_accumulation = [\n                                                                        {\n                                                                            key: byType,\n                                                                            is_accumulation: true\n                                                                        }\n                                                                    ];\n                                                                }\n                                                                var result = Object.assign({}, data, {\n                                                                    start_date: (_this = (data === null || data === void 0 ? void 0 : data.start_time) || '') === null || _this === void 0 ? void 0 : _this.replaceAll('-', ''),\n                                                                    end_date: (_this1 = (data === null || data === void 0 ? void 0 : data.end_time) || '') === null || _this1 === void 0 ? void 0 : _this1.replaceAll('-', ''),\n                                                                    page: 1,\n                                                                    page_size: 10,\n                                                                    multi_sort: [\n                                                                        {\n                                                                            sort_by: 'iaa_revenue',\n                                                                            desc: true\n                                                                        }\n                                                                    ],\n                                                                    accumulation: accumulation,\n                                                                    \"metrics\": [\n                                                                        \"iaa_revenue\",\n                                                                        \"iaa_avg_dau\",\n                                                                        \"iaa_arpu\",\n                                                                        \"ecpm\",\n                                                                        \"iaa_impressions\",\n                                                                        \"imps_per_dau\",\n                                                                        \"imps_per_viewers\",\n                                                                        \"ad_viewer_rate\",\n                                                                        \"iaa_viewers\",\n                                                                        \"funnel_cache_succ_rate_per\",\n                                                                        \"funnel_ready_rate_per\"\n                                                                    ]\n                                                                });\n                                                                delete result.start_time;\n                                                                delete result.end_time;\n                                                                delete result.by_type;\n                                                                result.logical_flag = 'overall_dimension_top';\n                                                                return result;\n                                                            }",
                              "formatData": "function(data) {\n                                                                var metricsList = (data === null || data === void 0 ? void 0 : data.metrics_list) || [];\n                                                                var dimensionFields = [\n                                                                    'country',\n                                                                    'region',\n                                                                    'system',\n                                                                    'ad_format',\n                                                                    'ua_network',\n                                                                    'campaign',\n                                                                    'version'\n                                                                ];\n                                                                var firstItem = metricsList[0] || {};\n                                                                var dimKey = dimensionFields.find(function(field) {\n                                                                    return !!(firstItem === null || firstItem === void 0 ? void 0 : firstItem[field]);\n                                                                });\n                                                                if (!dimKey && (firstItem === null || firstItem === void 0 ? void 0 : firstItem.custom_dimensions)) {\n                                                                    var customDim = firstItem.custom_dimensions[0];\n                                                                    if (customDim === null || customDim === void 0 ? void 0 : customDim.key) {\n                                                                        dimKey = customDim.key;\n                                                                    }\n                                                                }\n                                                                var activeDimKey = dimKey || 'country';\n                                                                var dimNameKey = \"\".concat(activeDimKey, \"_name\");\n                                                                var dwmList = (metricsList || []).map(function(item) {\n                                                                    var _metrics_iaa_revenue;\n                                                                    var metrics = (item === null || item === void 0 ? void 0 : item.metrics) || {};\n                                                                    var dimNameObj = item === null || item === void 0 ? void 0 : item.dimension_name;\n                                                                    var customDimensions = (item === null || item === void 0 ? void 0 : item.custom_dimensions) || [];\n                                                                    var nameEnKey = \"\".concat(activeDimKey, \"_name_en\");\n                                                                    // Extract name from top-level first, then custom_dimensions\n                                                                    var nameValue = (item === null || item === void 0 ? void 0 : item[activeDimKey]) || '';\n                                                                    var fullName = (dimNameObj === null || dimNameObj === void 0 ? void 0 : dimNameObj[nameEnKey]) || (item === null || item === void 0 ? void 0 : item[dimNameKey]) || nameValue;\n                                                                    if (!nameValue || !fullName) {\n                                                                        var matchingDim = customDimensions.find(function(cd) {\n                                                                            return cd.key === activeDimKey;\n                                                                        });\n                                                                        if (matchingDim) {\n                                                                            nameValue = nameValue || matchingDim.value || '';\n                                                                            fullName = fullName || matchingDim.name_en || matchingDim.name_ch || matchingDim.value || '';\n                                                                        }\n                                                                    }\n                                                                    var metricEntries = {};\n                                                                    Object.keys(metrics).forEach(function(metricKey) {\n                                                                        var metricData = metrics[metricKey] || {};\n                                                                        metricEntries[metricKey] = {\n                                                                            value: (metricData === null || metricData === void 0 ? void 0 : metricData.value) || '',\n                                                                            change: (metricData === null || metricData === void 0 ? void 0 : metricData.dod) || ''\n                                                                        };\n                                                                    });\n                                                                    return Object.assign({}, metricEntries, {\n                                                                        name: nameValue,\n                                                                        full_name: fullName || nameValue,\n                                                                        share_of_all: (metrics === null || metrics === void 0 ? void 0 : (_metrics_iaa_revenue = metrics.iaa_revenue) === null || _metrics_iaa_revenue === void 0 ? void 0 : _metrics_iaa_revenue.share_off_all) || ''\n                                                                    });\n                                                                });\n                                                                return {\n                                                                    dwm_list: dwmList,\n                                                                    dwm_data_list: []\n                                                                };\n                                                            }"
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "monetization/revenue",
                              "componentKey": "RevenueBreakdownCo"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "MetricComponent",
                  "path": "monetization/revenue",
                  "componentKey": "OverallTableCo",
                  "height": 757,
                  "data": {
                    "tableMetric": [
                      "iaa_revenue",
                      "iaa_dau",
                      "iaa_arpu",
                      "ecpm",
                      "iaa_impressions",
                      "imps_per_dau",
                      "imps_per_viewers",
                      "iaa_viewers",
                      "iaa_clicks",
                      "ad_viewer_rate",
                      "funnel_cache_succ_rate_per",
                      "funnel_ready_rate_per"
                    ]
                  },
                  "config": {
                    "props": {
                      "config": {
                        "api": {
                          "tableApi": "/api/v1/dashboard/pc/overview_daily/overall_performance",
                          "tableDownloadApi": "/api/v1/dashboard/pc/overview_daily/overall_performance/download"
                        },
                        "customFiltersConfig": {
                          "customSelectorsDimensions": [
                            {
                              "key": "ad_format",
                              "showSelector": true,
                              "showColumn": true,
                              "defaultValue": "255",
                              "includeInAccumulation": true,
                              "isAccumulationWhenAllSelected": false,
                              "labelEn": "Ad Format",
                              "labelCn": "广告类型",
                              "options": [
                                {
                                  "value": "255",
                                  "textEn": "All",
                                  "textCn": "全部",
                                  "isAll": true
                                },
                                {
                                  "value": "interstitial",
                                  "textEn": "Interstitial",
                                  "textCn": "插屏广告"
                                },
                                {
                                  "value": "rewarded",
                                  "textEn": "Rewarded",
                                  "textCn": "激励广告"
                                },
                                {
                                  "value": "banner",
                                  "textEn": "Banner",
                                  "textCn": "横幅广告"
                                }
                              ]
                            }
                          ]
                        },
                        "dimensionConfig": {
                          "filterDimsAndColumns": [
                            "ad_format"
                          ]
                        },
                        "customColumnsAfterDim": [
                          {
                            "columnKey": "ad_format",
                            "valueKey": "ad_format",
                            "nameEn": "Ad Format",
                            "nameCn": "广告类型",
                            "enWidth": 146,
                            "cnWidth": 120,
                            "type": "dimension",
                            "align": "left",
                            "fixed": "left"
                          }
                        ],
                        "downConfig": {}
                      }
                    }
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
